<template>
    <v-dialog
        :max-width="width"
        :model-value="modelValue"
        @update:model-value="handleDialogUpdate"
    >
        <v-card>
            <v-card-title class="text-h6 bg-primary">
                <v-icon class="mr-2">{{ icon }}</v-icon>
                {{ title }} 
            </v-card-title>
            <v-card-text style="white-space: pre-line">
                {{ message }}
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    v-if="falseText"
                    variant="text"
                    @click="$emit('cancel')"
                >
                    {{ falseText }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="text"
                    @click="$emit('confirm')"
                >
                    {{ trueText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Confirm'
        },
        trueText: {
            type: String,
            default: 'OK'
        },
        falseText: {
            type: String,
            default: 'Cancel'
        },
        message: {
            type: String,
            default: 'Are you sure?'
        },
        color: {
            type: String,
            default: 'primary'
        },
        icon: {
            type: String,
            default: 'mdi-information'
        },
        width: {
            type: Number,
            default: 350
        }
    },
    emits: ['close', 'confirm', 'cancel'],
    methods: {
        handleDialogUpdate(value) {
            if (!value) {
                this.$emit('close')
            }
        }
    }
}
</script>

<style>

</style>